import { Table as TableAntd } from 'antd';
import styled from 'styled-components';

export const Table = styled(TableAntd)`
  .ant-table {
    background: #141414;
  }
`;
